import React, { useState } from "react";
import PropTypes from 'prop-types';
import { 
  Tabs, Tab
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const tabsStyles = makeStyles(theme => ({
  root: {
    marginTop: "10px"
  },
}));

const NavigationTabs = (props) => {

  const { tabs, onChangeTab } = props;

  const classes = tabsStyles();
  const [currentTab, setCurrentTab] = useState(props.currentTab || tabs[0].identifier);

  const onChange = (event, newValue) => {
    const tabInfo = tabs.filter(tabInfo => newValue === tabInfo.identifier)[0];
    setCurrentTab(newValue);
    onChangeTab(newValue, tabInfo);
  }

  return (
    <div className = { classes.root } >
      <Tabs value = { currentTab } 
            onChange = { onChange } 
            variant = { "scrollable" }
            scrollButtons="auto" >
        {
          tabs.map((tab) => {
            return <Tab label = { tab.label } 
                        key = { tab.identifier } 
                        id = { tab.identifier }
                        value = { tab.identifier }
                        wrapped />
          })
        }
      </Tabs>
    </div>
  );
}

NavigationTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      identifier: PropTypes.string.isRequired,
      label :PropTypes.string.isRequired
    })
  ).isRequired,
  currentTab: PropTypes.string,
  onChangeTab: PropTypes.func.isRequired
};

NavigationTabs.defaultProps = {
}

export default NavigationTabs;